<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { Icon } from '@iconify/vue'
import { HighCode } from 'vue-highlight-code';
import 'vue-highlight-code/dist/style.css';
import { useToast } from 'primevue/usetoast'
import { usePackageDetailStore } from '@/modules/setting/stores/membership.detail.store.ts'
import Editor from 'primevue/editor';

const packageDetailStore = usePackageDetailStore()

interface Props {
  id: number,
  action: string,
}

const props = defineProps<Props>()

const fetched = ref('success')
const jsonData = ref<any>({})
const codeEditor = ref(null)
const pkgDesc = ref('')

const requestFetchData = async () => {
  try{

    packageDetailStore.fetchPackage(props.id)
  } catch (e) {

  }
}

const updateJsonData = (e: any) => {
  if(codeEditor.value){
    const raw = codeEditor.value.modelValue;
    // Loại bỏ dấu đơn ngoài nếu có
    const cleaned = raw.startsWith("'") ? raw.slice(1, -1) : raw;
    // Parse thành object
    const obj = JSON.parse(cleaned);
    console.log(obj); // => { cache: true }
  }

}


const membershipPackage = computed(() => {
  let membershipPkg;
  try{
    membershipPkg = packageDetailStore?.package[props.id] || null
  } catch (error) {
    membershipPkg = null;
  }
  return {
    status: membershipPkg?.package.status || '',
    name: membershipPkg?.package.name || '',
    description: membershipPkg?.package.description || '',
    price: membershipPkg?.package.price || '',
    period: membershipPkg?.package.period || '',
    created_at: membershipPkg?.package.created_at || '',
  }
})

const toast = useToast();


const resolver = (e: any) => {
  const errors: any = { fullname: [], phone: [], email: [], status: [], password: [], activation_status: [] };


  return {
    values: e.values,
    errors
  };
};

const onFormSubmit = (form: any) => {
  confirm.require({
    message: 'Bạn có muốn lưu các chỉnh sửa?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => {

      toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
  });
};

onMounted(() => {
  requestFetchData()
})


const handleSaveConfig = () => {

}

</script>

<template>
  <template v-if="'fetching' === fetched">
    <Card>
      <template #content>
        <div class="flex gap-3">
          Đang tải dữ liệu <Icon icon="eos-icons:three-dots-loading" width="24" height="24" />
        </div>
      </template>

    </Card>
  </template>
  <template v-if="'failed' === fetched">
    <Card class="bg-red-300">
      <template #content>
        <div class="flex flex-col gap-3 items-center">
          <Icon icon="fluent-color:error-circle-16" width="50" />
          <span class="font-300 text-[16px]">Lỗi khi tải dữ liệu này</span>
        </div>
      </template>

    </Card>
  </template>
  <template v-if="'success' === fetched">
    <div class="flex gap-5 mb-5">
      <div class="flex flex-1 flex-col">
        <Card>
          <template #title>
            <div class="flex justify-between">
              <div>Thông tin gói phí</div>
            </div>
          </template>
          <template #content>
            <Form
              v-slot="$form"
              :initial-values="membershipPackage"
              :resolver="resolver"
              @submit="onFormSubmit"
              class="flex w-full"
            >
              <div class="flex flex-col flex-3">
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Tên gói:</div>
                  <div class="flex-2">
                    <InputText name="name" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Chú thích gói phí:</div>
                  <div class="flex-2">
                    <Editor v-model="pkgDesc" editorStyle="height: 250px">
                      <template v-slot:toolbar>
                        <span class="ql-formats">
                            <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                            <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                            <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                        </span>
                      </template>
                    </Editor>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Giá:</div>
                  <div class="flex-2">
                    <InputText name="price" type="number" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Thời hạn:</div>
                  <div class="flex-2">
                    <InputText name="period" type="number" class="form-control" :disabled="false"/>
                  </div>
                </div>

                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Trạng thái hoạt động:</div>
                  <div class="flex-2">
                    <Select name="activation_status" :options="[
              {name: 'Hoạt động', code: 'LIVE'},
              {name: 'Ngưng hoạt động', code: 'DEPRECATED'},
            ]" optionLabel="name" placeholder="Chọn trạng thái" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3" v-if=false>
                  <div class="flex-1 text-right"></div>
                  <div class="flex-2">
                    <button type="submit" class="btn btn-cs success lg">Lưu chỉnh sửa</button>
                  </div>
                </div>
              </div>
            </Form>
          </template>
        </Card>

      </div>
      <div class="flex flex-1 flex-col">
        <Card>
          <template #title>
            <div class="flex justify-between">
              <div>Cấu hình</div>
              <div class="flex gap-2">
                <button type="button" class="btn btn-cs success" @click="handleSaveConfig">
                  Lưu chỉnh sửa
                </button>
              </div>
            </div>
          </template>
          <template #content>
            <div class="mt-5">
              <h4>Giao diện</h4>
              <HighCode
                :textEditor="true"
                :codeLines="false"
                :codeValue="JSON.stringify(jsonData)"
                lang="json"
                langName="json"
                width="100%" height="300px" fontSize="12px"
                :copy="false"
                theme="light"
                borderRadius="8px"
                ref="codeEditor"
                @change="updateJsonData"
              />
            </div>
            <div class="mt-5">
              <h4>Giá trị</h4>
              <HighCode
                :textEditor="true"
                :codeLines="false"
                :codeValue="JSON.stringify(jsonData)"
                lang="json"
                langName="json"
                width="100%" height="300px" fontSize="12px"
                :copy="false"
                theme="light"
                borderRadius="8px"
                ref="codeEditor"
                @change="updateJsonData"
              />
            </div>
          </template>
        </Card>
      </div>
    </div>
  </template>
</template>

<style scoped>

</style>
